import { render, staticRenderFns } from "./AssignSchoolModal.vue?vue&type=template&id=302f9715&scoped=true"
import script from "./AssignSchoolModal.vue?vue&type=script&lang=js"
export * from "./AssignSchoolModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302f9715",
  null
  
)

export default component.exports